module.exports = __webpack_public_path__ + "static/media/test-1400px.f8398a0f.png";